import type {
    SchemaCountByTimeRangeType,
    SchemaResultCountByTimeRange,
} from "./model.js";

export function csvEscape(value: unknown): string {
    const raw = String(value ?? "");

    if (/[",\n\r;]/.test(raw))
        return `"${raw.replace(/"/g, `""`)}"`;

    return raw;
}

export function downloadCsv(filename: string, rows: unknown[][]): void {
    const csv = rows
        .map((row) => row.map(csvEscape).join(";"))
        .join("\n");
    const blob = new Blob([ `\uFEFF${csv}` ], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url);
}

export function toDateTimeLocal(value: number): string {
    const date = new Date(value - new Date(value).getTimezoneOffset() * 60_000);

    return date.toISOString().slice(0, 16);
}

export function fromDateTimeLocal(value: string): number {
    const time = new Date(value).getTime();

    return Number.isFinite(time) ? time : Date.now();
}

export function buildPeriodLabels(after: number, timeRange: number, length: number): string[] {
    return Array.from({ length }, (_, index) => {
        const bucketStart = after + index * timeRange;
        const bucketEnd = bucketStart + timeRange;

        return `${new Date(bucketStart).toLocaleString()} → ${new Date(bucketEnd).toLocaleString()}`;
    });
}

export function getStatsExportRows(
    result: SchemaResultCountByTimeRange,
    timeElement: SchemaCountByTimeRangeType,
    after: number,
    timeRange: number,
): unknown[][] {
    const datasets = Object.entries(result.values);
    const length = Math.max(0, ...datasets.map(([ , values ]) => values.length));
    const labels = buildPeriodLabels(after, timeRange, length);

    return [
        [ "Période", ...datasets.map(([ name ]) => timeElement.properties.find((property) => property.name === name)?.label || name) ],
        ...labels.map((label, index) => [
            label,
            ...datasets.map(([ , values ]) => values[index] ?? 0),
        ]),
    ];
}
